import { render, staticRenderFns } from "./ChargingSettingsTabs.vue?vue&type=template&id=3a96726a&scoped=true"
import script from "./ChargingSettingsTabs.vue?vue&type=script&lang=js"
export * from "./ChargingSettingsTabs.vue?vue&type=script&lang=js"
import style0 from "./ChargingSettingsTabs.vue?vue&type=style&index=0&id=3a96726a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96726a",
  null
  
)

export default component.exports